/**
 * SectionHeading — Tier 0 module-local primitive per ADR
 * `frontend-0004` (`docs/adr/frontend-0004-ui-kit-doctrine.md`). Lives
 * in this module's `_components/` folder because Tier 3 promotion to
 * `@sparta/ui-kit` requires a real cross-slice import in code, which
 * does not exist on this branch. Stays at Tier 0 until that reactive
 * trigger fires.
 *
 * Visual: a small all-caps eyebrow heading. Uses `--fg-tertiary` from
 * the admin theme so it stays calm against the section card chrome
 * below it. Accepts an `id` so a surrounding scroll-anchor `<section>`
 * can wire `aria-labelledby` to it.
 */
import * as React from 'react';

export interface SectionHeadingProps {
  readonly children: React.ReactNode;
  /** Optional HTML id — used by enclosing `<section aria-labelledby={id}>`. */
  readonly id?: string;
}

export function SectionHeading({
  children,
  id,
}: SectionHeadingProps): React.ReactElement {
  return (
    <h2
      id={id}
      className="mb-3 pl-0.5 text-[11px] font-bold uppercase tracking-wider text-[var(--fg-tertiary)]"
    >
      {children}
    </h2>
  );
}
